

const LoadingAnimation = () => {
    return (
        <div className="flex items-center justify-center my-6">
            <div className="relative">
                <div className="w-24 h-24 rounded-full flex items-center justify-center bg-indigo-800">
                    <div className="flex space-x-2">
                        <div className="w-[8px] h-[8px] bg-primary-500 rounded-full animate-dot [animation-delay:0s]" />
                        <div className="w-[8px] h-[8px] bg-primary-500 rounded-full animate-dot [animation-delay:0.2s]" />
                        <div className="w-[8px] h-[8px] bg-primary-500 rounded-full animate-dot [animation-delay:0.4s]" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingAnimation;